import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_476: DocMigration = {
  maxSchemaVersion: "0.0.476",
  description: "View template dimension witness lines visibility",
  apply(json: any) {
    const { viewTemplates } = json;

    const migrateCategoryVisibility = (categories: string[], srcCategory: string, dstCategory: string): string[] => {
      if (categories.includes(srcCategory)) {
        return [...categories, dstCategory];
      } else {
        return categories.filter((category) => category !== dstCategory);
      }
    };

    const categoriesToMigrate: { srcCategory: string; dstCategory: string }[] = [
      { srcCategory: "DIM_LINEWORK", dstCategory: "DIM_WITNESS" },
      { srcCategory: "ANNOT_DIM_LINEWORK", dstCategory: "ANNOT_DIM_WITNESS" },
      { srcCategory: "ALL_LVL_ANNOT_DIM_LINEWORK", dstCategory: "ALL_LVL_ANNOT_DIM_WITNESS" },
      { srcCategory: "FOUNDATION_DIM_LINEWORK", dstCategory: "FOUNDATION_DIM_WITNESS" },
      { srcCategory: "WALL_INTERIOR_DIM_LINEWORK", dstCategory: "WALL_INTERIOR_DIM_WITNESS" },
      { srcCategory: "WALL_EXTERIOR_DIM_LINEWORK", dstCategory: "WALL_EXTERIOR_DIM_WITNESS" },
      { srcCategory: "ROOF_OVERHANG_DIM_LINEWORK", dstCategory: "ROOF_OVERHANG_DIM_WITNESS" },
      { srcCategory: "UTILITY_DIM_LINEWORK", dstCategory: "UTILITY_DIM_WITNESS" },
    ];

    for (const viewTemplateId in viewTemplates) {
      const viewTemplate = viewTemplates[viewTemplateId];

      for (const categoryToMigrate of categoriesToMigrate) {
        viewTemplate.categories = migrateCategoryVisibility(
          viewTemplate.categories,
          categoryToMigrate.srcCategory,
          categoryToMigrate.dstCategory,
        );
      }
    }
    return json;
  },
};

export default migration_0_0_476;
